<template>
  <a :href="smsContent">
    <slot />
  </a>
</template>

<script>
import { formatIntlPhoneNumber } from '@/util/formatters';

export default {
  name: 'BaseSms',
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
    textMessage: {
      type: String,
      default:
        "Hi, I'm interested in this vehicle. Could you please send me more information? Thank you! Vehicle: -",
    },
  },
  computed: {
    smsContent() {
      const formatedPhoneNumber = formatIntlPhoneNumber(this.phoneNumber);
      const encodedTextMessage = encodeURIComponent(this.textMessage);

      return `sms:${formatedPhoneNumber}&body=${encodedTextMessage}`;
    },
  },
};
</script>
